<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="500">
        <v-card-title>
            Servicios Complementarios (Red de Proveedores)
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-row dense>
                <v-col cols="12" v-for="(item,k) in lists" :key="k" :sm="_.size(lists) > 3 ? 4 : 6">
                    <v-card min-height="200" elevation="8" raised>
                        <v-card-title style="background-color:#FF4132">
                            <h1 class="headline white--text" v-html="item.proveedor"></h1>
                        </v-card-title>
                        <v-card-subtitle style="background-color:#FF4132" 
                                        class="subtitle-1 white--text" v-text="item.nombreServicioComp">
                        </v-card-subtitle>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="8">
                                    <p class="subtitle-1 mt-4 black--text" v-html="item.nombreServicioCompPresentacion"></p>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-img :src="`data:image/jpeg;base64,${item.icono}`" contain max-height='100'></v-img>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
export default {
    name:'ServicioComplementarioCliente',
     data: () => ({
            ob:{
                opcion:'LISTAR',
                fechaVigenciaIni:moment().format('YYYY-MM-DD'),
                idEstado:1
            },
            lists:{}
        }),
    created(){
         var error = 'E';
            axios.post(`${BASE_URI}administrador/servicio-complementario/listar`,this.ob)
                 .then((r)=>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                        this.$set(this,'lists',r.data.data);
                 })
                 .catch((e)=>{
                    mensajesAlerta(e,error);
                 });
    }
}
</script>
